import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { FocusHandlingFormEngine } from "./components/focusHandlingForm";

const focusHandlingFormEngineModule = (): Module => ({
	id: "FocusHandlingFormEngine",
	views: () => viewComponentProvider,
	sagas: () => []
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	FocusHandlingFormEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default focusHandlingFormEngineModule;
